import { useMemo } from "react";
import { Link, useHistory, useParams } from "react-router-dom";
import PropTypes from "prop-types";
import { useSelector } from "react-redux";

import { dispatch } from "../../../state/store";
import {
  resetConsentElements,
  setBreadcrumbsRedirectUrl,
  setSelectedConsent
} from "../../../state/ducks";

import { routePaths, strCode } from "../../../consts";
import { t } from "../../../services";

import { BreadcrumbContainer } from "../styled";
import { LinkStyled } from "../../NavLink/styled";

const ConsentsBreadcrumb = ({
  slashBefore = false,
  slashAfter = false,
  onClick,
  isSameConsentData
}) => {
  const consentMarket = useSelector((store) => store.consents.market);
  const allMarkets = useSelector((store) => store.markets.markets);

  const { appName } = useParams();

  const history = useHistory();

  const isDisable = useMemo(() => {
    return (
      !isSameConsentData &&
      (history.location.pathname.includes(routePaths.CONSENT_ELEMENT_CREATE) ||
        history.location.pathname.includes(routePaths.CONSENT_ELEMENT_EDIT))
    );
  }, []);

  const marketName = useMemo(() => {
    return allMarkets?.find((market) => market.market === consentMarket)?.name || "";
  }, [consentMarket, allMarkets?.length]);

  const resetConsentData = () => {
    dispatch(setSelectedConsent(null));
    dispatch(resetConsentElements());
  };

  return (
    <LinkStyled
      as={isSameConsentData ? Link : "button"}
      to={`${routePaths.APPS}/${appName}${routePaths.CONSENTS}`}
      onClick={() => {
        if (isSameConsentData) {
          resetConsentData();
        } else {
          dispatch(
            setBreadcrumbsRedirectUrl(`${routePaths.APPS}/${appName}${routePaths.CONSENTS}`)
          );
          onClick && onClick();
        }
      }}
      disabled={isDisable}>
      <BreadcrumbContainer slashBefore={slashBefore} slashAfter={slashAfter}>
        {`${marketName} ${t(strCode.CONSENTS_NAV_BTN)}`}
      </BreadcrumbContainer>
    </LinkStyled>
  );
};

ConsentsBreadcrumb.propTypes = {
  slashBefore: PropTypes.bool,
  slashAfter: PropTypes.bool,
  isSameConsentData: PropTypes.bool,
  onClick: PropTypes.func
};

export default ConsentsBreadcrumb;
